<template>
   <section id="classPage" class="class-page" style="padding:15px;">
        <class-page-header :course="course" :menu="menu" :details="details" :current-section="parseInt(sectionData.FOLDER_ID)" :course-content="courseContent"></class-page-header>
       
       <div class="class-page-body">
            <div v-html="sectionData.FOLDER_CONTENT"></div>   
            <class-items :items-data="sectionData.REPORTS" folder-type="P"></class-items>
       </div>
        
        <class-page-footer :course="course" :menu="menu" :current-section="parseInt(sectionData.FOLDER_ID)" :course-content="courseContent" />
        
    </section>
</template>
<script>

import { mapGetters } from 'vuex';
import ClassPageHeader from "./Header.vue";
import ClassPageFooter from "./Footer.vue";
import ClassItems from "./ClassItems.vue";

import ClassPageHomeResource from '../../api/ClassPageHome';
import ClassPageDetailsResource from '../../api/ClassPageDetails';
import ClassPageMenuResource from '../../api/ClassPageMenu';
import ClassPageSectionResource from '../../api/ClassPageSection';
import CoursesResource from '../../api/Courses';

export default {
		components: {
			ClassPageHeader,
			ClassPageFooter,
			ClassItems
		},
		props: {
			section : { 
				type: Number,
				default: 1
			}
		},
		data() {
			return {
				sectionData: {},
				menu: [],
				details: {},
				course: {},
				courseContent:{}
			}
		},
		computed: {
			...mapGetters(['selectedStudent', 'roleRules']),
		},
		created() {
			this.$store.commit('setUseHeader', false);
			this.fetchSection();
			this.fetchMenu();
			this.fetchDetails();
			this.fetchCourse();
			this.fetchClassHome();
    },
		methods: {
			fetchSection(){
				const ClassPageSection = new ClassPageSectionResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
						folderId: this.$route.params.folderId,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					}
				});

				ClassPageSection.get().then(() => {
					this.sectionData = ClassPageSection.getResponseData();
				});
			},
			fetchMenu(){
				const ClassPageMenu = new ClassPageMenuResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				ClassPageMenu.get().then(()=>{
					this.menu = ClassPageMenu.getResponseData();
				});
			},
			fetchDetails(){
				const ClassPageDetails = new ClassPageDetailsResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				ClassPageDetails.get().then(()=>{
					this.details = ClassPageDetails.getResponseData();
				});
			},
			fetchCourse(){
				const Course = new CoursesResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				Course.get().then(()=>{
					this.course = Course.getResponseData();
				});
			},
			fetchClassHome(){
				const ClassPageHome = new ClassPageHomeResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				ClassPageHome.get().then(()=>{
					this.courseContent = ClassPageHome.getResponseData().COURSE_CONTENT;
				});
			}
		}
}
</script>